import { request } from '@/utils/request'

export const reqReserveInfo = (id) => request.get(`reservation/info?id=${id}`)

/* parmas的型態
Iparams = {
  npp: number;
  page: number;
  keyword: string;
  start: number;
  end: number;
  task: string | null;
}; */

// 取得立即單 task=record, havecar, servicecall, appteam, specialpassengernoncar
export const reqInstantList = (params) =>
  request.get(`transaction/list`, { params })

export const reqInstantById = (id, task) =>
  request.get(`transaction/${id}?task=${task}`)

export const reqUpdateInstant = (payload) =>
  request.put(`updatetransaction`, payload)
// 取得路招單 task=roadHail
export const reqRoadList = (params) =>
  request.get(`transaction/list`, { params })

// 取得預約前派單 task=record
export const reqReserveBeforeList = (params) =>
  request.get(`reservation/list`, { params })

// 取得預約後派單 沒有task屬性
export const reqReserveAfterList = (params) =>
  request.get(`delayHail/list`, { params })

// 取得機場接送單
export const reqAirportTransferList = (params) =>
  request.get(`airportTransfer/list`, { params })

export const reqServiceStaff = (id) => request.get(`delayHail/services/${id}`)

export const reqUpdateArriveTime = (id) =>
  request.get(`google/get_update_arrive_time?id=${id}`)



// WEBPACK FOOTER //
// ./src/api/transaction/index.js